import React, { useCallback } from "react";

const getMimeType = (filename) => {
    const ext = filename?.split('.').pop()?.toLowerCase();
    const mimeTypes = {
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        txt: 'text/plain',
    };
    return mimeTypes[ext] || 'application/octet-stream';
};

const isOfficeDocument = (filename) => {
    const ext = filename?.split('.').pop()?.toLowerCase();
    return ['docx', 'xlsx', 'doc', 'xls'].includes(ext);
};

const DownloadDocumentButton = ({ url, fileName, className, text }) => {
    const handleDownload = useCallback(async () => {
        // For Office documents (docx, xlsx, etc.) use direct link to avoid blob conversion issues
        if (isOfficeDocument(fileName)) {
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }

        // For other formats use fetch/blob
        try {
            const response = await fetch(url);
            const data = await response.blob();
            const mimeType = getMimeType(fileName);
            const blob = new Blob([data], { type: mimeType });
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download failed:', error);
        }
    }, [url, fileName]);

    return (
        <button onClick={handleDownload} className={className}>
            {text}
        </button>
    );
};

export default DownloadDocumentButton;
